import React, { useEffect } from 'react';
import { trans } from '../../../_providers/Translation'

function SubscriptionType(props) {

    return (
        <table>
            <thead>
                <tr>
                    <th>{trans('tables.activity')}</th>
                    <th>{trans('tables.date')}</th>
                    <th>{trans('tables.employee')}</th>

                    <th>{trans('tables.price')}</th>
                    <th>{trans('tables.period')}</th>
                    <th>{trans('tables.auto_invoicing_allowed')}</th>
                    <th>{trans('tables.has_payment_terms')}</th>
                    <th>{trans('tables.payment_terms_value')}</th>
                    <th>{trans('tables.payment_terms_unit')}</th>
                </tr>
            </thead>
            <tbody>
                {props.data.map((h, i) => (
                    <tr key={i} className={[h.actual ? 'actual' : h.selected ? 'selected' : '']}>
                            <td>{h.event}</td>
                            <td>{h.date}</td>
                            <td>{h.causer ? `${h.causer.name} ${h.causer.lastname}` : '-'}</td>

                            <td>{h.subject?.price ?? '-'}</td>
                            <td>{h.subject?.period ?? '-'}</td>
                            <td>{h.subject?.auto_invoicing_on ? trans('tables.yes') : trans('tables.no')}</td>
                            <td>{h.subject?.has_payment_terms ? trans('tables.yes') : trans('tables.no')}</td>
                            <td>{h.subject?.payment_terms_value ?? '-'}</td>
                            <td>{h.subject?.payment_terms_unit ?? '-'}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}

export default SubscriptionType;